/**
 * Resolve an S3 key or URL to a displayable URL.
 * - Full URLs (http/https) pass through unchanged
 * - S3 keys are prefixed with /api/s3/ proxy (never expires)
 */
export function resolveMediaUrl(urlOrKey: string | undefined | null): string {
  if (!urlOrKey) return '';
  if (urlOrKey.startsWith('http')) return urlOrKey;
  if (urlOrKey.startsWith('/api/')) return urlOrKey;
  return `/api/s3/${urlOrKey}`;
}
